import 'core-js';
import 'whatwg-fetch';
import 'url-search-params-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import './index.pcss';

ReactDOM.render(<App />, document.getElementById('gia-appeal'));
